import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';


async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    // headers: { 'accessToken': args[0] },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function getPriceData([url, ticker, start_date, end_date, allData]) {
  const data = await fetchAPI(
    `query {
        getStockDataV2(ticker: "${ticker}", start_date: "", limit: 1000, allData: ${allData}) {
          value: price
          recordDate: recordDatetime
          adj_open
          adj_high
          adj_low
          adj_close
          volume
          # rdt: recordDatetime
          # r
          # rdt
          # price
          # p
          # rn
        }
      }`)
  return data
}
